module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page006"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_0"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_1"
    }
  }, [_vm._v("FRENCH CUISINE")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_2"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("uisine")]), _vm._v(" F"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("rançaise")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_3"
    }
  }, [_vm._v("Since the fifteenth century, the cuisine")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_4"
    }
  }, [_vm._v("cuisine’ spread around the country")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_5"
    }
  }, [_vm._v("of France has been the most influential")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_6"
    }
  }, [_vm._v("and abroad, becoming renowned the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_7"
    }
  }, [_vm._v("in Europe. It was at that time that the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_8"
    }
  }, [_vm._v("world over. Great importance was at-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_9"
    }
  }, [_vm._v("first cookery books were printed in the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_10"
    }
  }, [_vm._v("tached to culinary pleasure, particular-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_11"
    }
  }, [_vm._v("French language.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_12"
    }
  }, [_vm._v("ly among the upper classes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_13"
    }
  }, [_vm._v("In the seventeenth and eighteenth")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_14"
    }
  }, [_vm._v("Haute cuisine originated in the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_15"
    }
  }, [_vm._v("centuries, the French court was con-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_16"
    }
  }, [_vm._v("nineteenth century and developed")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_17"
    }
  }, [_vm._v("sidered to be the most culturally ad-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_18"
    }
  }, [_vm._v("into the French national cuisine. It is")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_19"
    }
  }, [_vm._v("vanced, and as a result, the French style")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_20"
    }
  }, [_vm._v("characterised by its very high quality")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_21"
    }
  }, [_vm._v("of cooking was adopted by the kitch-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_22"
    }
  }, [_vm._v("and versatility. However, many dif-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_23"
    }
  }, [_vm._v("ens of many noble houses throughout")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_24"
    }
  }, [_vm._v("ferent styles of regional cooking can")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_25"
    }
  }, [_vm._v("Europe. It was the origin of the tra-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_26"
    }
  }, [_vm._v("also be found throughout the country,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_27"
    }
  }, [_vm._v("ditional sequence of soup main course")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_28"
    }
  }, [_vm._v("making use of local produce, combi-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_29"
    }
  }, [_vm._v("and dessert typical of Western meals,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_30"
    }
  }, [_vm._v("nations of ingredients and preparato-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_31"
    }
  }, [_vm._v("and of set meals consisting of multiple")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_32"
    }
  }, [_vm._v("ry methods. Among the best-known")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_33"
    }
  }, [_vm._v("courses.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_34"
    }
  }, [_vm._v("styles of regional cooking are those of")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_35"
    }
  }, [_vm._v("Normandy, Brittany and Provence. In")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_36"
    }
  }, [_vm._v("Food has always been an important")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_37"
    }
  }, [_vm._v("simple terms, the food in the south of")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_38"
    }
  }, [_vm._v("part in the daily life of the French,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_39"
    }
  }, [_vm._v("France is Mediterranean in style, while")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_40"
    }
  }, [_vm._v("even today. At the time of the French")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_41"
    }
  }, [_vm._v("that of the inland regions is heartier.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_42"
    }
  }, [_vm._v("Revolution, an increasing number of")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_43"
    }
  }, [_vm._v("restaurants were opened, giving the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_44"
    }
  }, [_vm._v("French cuisine is often associated")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_45"
    }
  }, [_vm._v("middle classes greater access to the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_46"
    }
  }, [_vm._v("with "), _c('span', {
    staticClass: "page006_46a"
  }, [_vm._v("l’art de vivre")]), _vm._v(", the art of living.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_47"
    }
  }, [_vm._v("finest culinary arts. Cooks established")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_48"
    }
  }, [_vm._v("This book intends to show how this art")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_49"
    }
  }, [_vm._v("standards of preparation and quality")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_50"
    }
  }, [_vm._v("can also be fully enjoyed in its vegan")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_51"
    }
  }, [_vm._v("for the dishes they served in their res-")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_52"
    }
  }, [_vm._v("version. With this in mind, we wish")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_53"
    }
  }, [_vm._v("taurants. This newly developed ‘grande")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page006_54"
    }
  }, [_vm._v("you "), _c('span', {
    staticClass: "page006_54a"
  }, [_vm._v("bonne chance")]), _vm._v(" and "), _c('span', {
    staticClass: "page006_54b"
  }, [_vm._v("bon appétit")]), _vm._v("!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d024e78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_006.vue
// module id = 72
// module chunks = 0